'use client';
import React from 'react';
import PrivacyPolicy from "../../../components/organisms/privacyPolicy"

const PrivacyPolicyPage = () => {
    return (
        <PrivacyPolicy />
    );
};

export default PrivacyPolicyPage;